import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errText } from "../../lib/api";
import { Logo } from "../../components/store/Logo";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin/login";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/admin/auth/login", { email, password });
      nav("/admin", { replace: true });
    } catch (err) {
      toast.error(errText(err, "بيانات الدخول غير صحيحة"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div dir="rtl" className="grid min-h-screen bg-ivory lg:grid-cols-2" style={{ fontFamily: "Tajawal, sans-serif" }}>
      <div className="grain relative hidden bg-ink lg:block">
        <img src="/images/silk.jpg" alt="" className="h-full w-full object-cover opacity-60" />
      </div>
      <form onSubmit={submit} className="flex flex-col justify-center px-8 py-16 sm:px-20" data-testid="admin-login-form">
        <Logo />
        <h1 className="mt-12 text-3xl">لوحة الإدارة</h1>
        <p className="mt-2 text-sm text-ink/60">الدخول مخصص لإدارة المتجر فقط</p>
        <input data-testid="admin-email-input" type="email" required dir="ltr" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="field mt-10" />
        <input data-testid="admin-password-input" type="password" required dir="ltr" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="field mt-6" />
        <button data-testid="admin-login-submit" disabled={busy} className="btn-ink mt-10">{busy ? "..." : "تسجيل الدخول"}</button>
        <div className="my-6 flex items-center gap-4 text-xs text-ink/50"><span className="h-px flex-1 bg-sand" />أو<span className="h-px flex-1 bg-sand" /></div>
        <button type="button" data-testid="admin-google-login-button" onClick={googleLogin} className="btn-line">الدخول عبر Google</button>
        <p className="mt-3 text-xs text-ink/50">متاح فقط للإيميلات المسجلة في «الموظفون والصلاحيات»</p>
      </form>
    </div>
  );
}
